export default class LocatorSearch {
  constructor({ onNewCoordinates }) {
    const _ = this;

    // Elements
    _.$form = document.querySelector('.js-locator-search');
    _.$coordInput = _.$form.querySelector('.js-locator-search-coordinates');
    _.$input = _.$form.querySelector('.js-locator-search-input');
    _.$dismiss = _.$form.querySelector('.js-locator-search-dismiss');
    _.$submit = _.$form.querySelector('.js-locator-search-submit');

    // Various vars
    _.userInput = _.$input.value;
    _.IS_DISABLED = true;

    // Google autocomplete
    _.autocomplete = new google.maps.places.Autocomplete(_.$input, {
      componentRestrictions: {country: "fr"}
    });
    _.autocomplete.setFields(["geometry"]);

    // Events
    _.handlePlaceChange = _.handlePlaceChange.bind(_);
    _.handleSubmit = _.handleSubmit.bind(_);
    _.handleTyping = _.handleTyping.bind(_);
    _.handleDismiss = _.handleDismiss.bind(_);

    _.onNewCoordinates = onNewCoordinates || function(latLng) {};
  }

  init() {
    const _ = this;

    _.autocomplete.addListener("place_changed", _.handlePlaceChange);
    _.$form.addEventListener('submit', _.handleSubmit);
    _.$input.addEventListener('keyup', _.handleTyping);
    _.$dismiss.addEventListener('click', _.handleDismiss);
  }

  // Update coordinates and enable form's submission
  handlePlaceChange() {
    const _ = this;

    const place = _.autocomplete.getPlace();

    if (place.geometry) {
      _.$coordInput.value = `${place.geometry.location.lat()}, ${place.geometry.location.lng()}`;
      _.$submit.disabled = false;
      _.userInput = _.$input.value;
      _.IS_DISABLED = false;
      // Reset focus on input (was lost if slection was made by click)
      _.$input.focus();
    }
  }

  handleSubmit(e) {
    const _ = this;

    e.preventDefault();
    _.dispatchNewCoordinates();
  }

  // Trigger defined callback when coordinates are changing (new location, clear)
  dispatchNewCoordinates() {
    const _ = this;

    const coords = _.$coordInput.value ? _.$coordInput.value.split(', ') : false;
    _.onNewCoordinates(coords ? { lat: parseFloat(coords[0]), lng: parseFloat(coords[1]) } : coords);
  }

  // Prevent user to submit form if searching anything else that isn't a google place
  handleTyping() {
    const _ = this;

    if (!_.IS_DISABLED && _.$input.value !== _.userInput) {
      _.clear(false);
    }

    _.userInput = _.$input.value;
  }

  // Clear search and saved coordinates
  handleDismiss() {
    const _ = this;

    _.clear();
    _.dispatchNewCoordinates();
  }

  clear(clearUserInput = true) {
    const _ = this;

    if (clearUserInput) _.$input.value = '';
    _.$coordInput.value = '';
    _.$submit.disabled = true;
    _.IS_DISABLED = false;
  }
}
